import React from "react";
import CheckboxIcon from "../svg/checkboxIcon";
import CheckboxIconChecked from "../svg/checkboxIcon-checked";

type CheckboxButtonProps = {
    id: string;
    label: string;
    checked: boolean;
    value?: string;
    topText?: string;
    hasError?: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const CheckboxButton: React.FC<CheckboxButtonProps> = ({ id, label, checked, value, topText, hasError, onChange }) => {
    return (
        <div className="flex flex-col items-start relative w-full">
            {topText && (
                <span className="absolute -top-2 left-[14px] text-[12px] text-violet-300 leading-[133%] tracking-[0.03em] uppercase bg-white px-[4px] py-[2px] transition-all max-[576px]:text-[10px]">
                    {topText}
                </span>
            )}
            <div className={`flex items-center border-[1.5px] ${hasError ? 'border-red-500' : 'border-violet-50'} rounded-[12px] p-4 w-full transition-all max-[576px]:p-[14px]`}>
                <input
                    type="checkbox"
                    id={id}
                    checked={checked}
                    onChange={onChange}
                    className="hidden"
                    value={value}
                />
                <label htmlFor={id} className="relative pr-[36px] cursor-pointer text-black font-semibold inline-block w-full">
                    <span className="absolute right-0 top-0 w-[24px] h-[24px] rounded-full">
                        <CheckboxIcon />
                    </span>
                    <span className={`absolute right-0 top-0 w-[24px] h-[24px] rounded-full transition-all ${checked ? 'scale-100 opacity-100' : 'scale-0 opacity-0'}`}>
                        <CheckboxIconChecked />
                    </span>
                    {label}
                </label>
            </div>
            {hasError && <p className="text-red-500 text-sm mt-1">Please select at least one option.</p>}
        </div>
    );
};

export { CheckboxButton };
